import { Box, Typography } from "@mui/material";
import { IDOAShift } from "../../availability-administration/AvailabilityAdministrationData";
import { IEmployee } from "../AvailabilityAdministrationData";
import { AvailableCode, SUCCESS_MSG } from "./../AvailabilityAdministrationModel";
import { actionMsgStyle } from "./../styled";

interface IActionMessageProps {
  shift?: IDOAShift,
  employeeData: IEmployee,
  actionMsg?: string,
  selectedRegId: string,
  availableForBothDoaSelection: number,
  isDispatchTypeSix: boolean,
  statusMsgClassname: string,
  isNightDispatch: boolean,
}

export const ActionMessage: React.FC<IActionMessageProps> = ({
  shift,
  employeeData,
  actionMsg,
  selectedRegId,
  availableForBothDoaSelection,
  isDispatchTypeSix,
  statusMsgClassname,
  isNightDispatch
}) => (
  <Box sx={actionMsgStyle} data-automation="status-event-desc">
    {actionMsg && actionMsg === SUCCESS_MSG && <>
      {employeeData?.empInfo?.status && !isDispatchTypeSix && !isNightDispatch && <Typography className={`status-wrapper ${statusMsgClassname}`}>
        <Typography component='span'>Employee {selectedRegId} has been made </Typography>
        {!employeeData?.empInfo?.doaSelections ? 'unavailable' : 'available'}
        <Typography component='span'> for the {shift?.shiftDescription} Shift {employeeData?.empInfo?.doaSelections ? `on ${employeeData?.empInfo?.shiftDate}.` : '.'}</Typography>
      </Typography>}
      {isDispatchTypeSix && employeeData?.empInfo?.doaSelections === AvailableCode.OPTION_1 &&
        <Typography className={`status-wrapper ${statusMsgClassname}`}>
          <Typography component='span'>Employee {selectedRegId} has been made </Typography>
          available
          <Typography component='span'> for the 7AM Shift on {employeeData?.empInfo?.shiftDate} with NO OUTPORTS option.</Typography>
        </Typography>}
      {isDispatchTypeSix && employeeData?.empInfo?.doaSelections === AvailableCode.OPTION_2 &&
        <Typography className={`status-wrapper ${statusMsgClassname}`}>
          <Typography component='span'>Employee {selectedRegId} has been made </Typography>
          available
          <Typography component='span'> for the 8AM Shift on {employeeData?.empInfo?.shiftDate} with ONLY SQUAMISH option.</Typography>
        </Typography>}
      {isDispatchTypeSix && employeeData?.empInfo?.doaSelections === availableForBothDoaSelection &&
        <Typography className={`status-wrapper ${statusMsgClassname}`}>
          <Typography component='span'>Employee {selectedRegId} has been made </Typography>
          available
          <Typography component='span'> for the 7AM AND 8AM Shifts on {employeeData?.empInfo?.shiftDate}</Typography>
        </Typography>}
      {isDispatchTypeSix && employeeData && !employeeData?.empInfo?.doaSelections &&
        <Typography className={`status-wrapper ${statusMsgClassname}`}>
          <Typography component='span'>Employee {selectedRegId} has been made </Typography>
          unavailable
          <Typography component='span'> for the 7AM AND 8AM Shifts.</Typography>
        </Typography>}
      {isNightDispatch && employeeData && !employeeData?.empInfo?.doaSelections && !employeeData.empInfo.dependentShift?.doaSelections &&
        <Typography className={`status-wrapper ${statusMsgClassname}`}>
          <Typography component='span'>Employee {selectedRegId} has been made </Typography>
          unavailable
          <Typography component='span'> for the NIGHT Shift and GRAVEYARD Shift.</Typography>
        </Typography>}
      {isNightDispatch && employeeData && !!employeeData?.empInfo?.doaSelections && !!employeeData.empInfo.dependentShift?.doaSelections &&
        <Typography className={`status-wrapper ${statusMsgClassname}`}>
          <Typography component='span'>Employee {selectedRegId} has been made </Typography>
          available
          <Typography component='span'> for the NIGHT Shift on {employeeData?.empInfo?.shiftDate} and GRAVEYARD Shift on {employeeData?.empInfo?.dependentShift?.shiftDate}.</Typography>
        </Typography>}
      {isNightDispatch && employeeData && !!employeeData?.empInfo?.doaSelections && !employeeData.empInfo.dependentShift?.doaSelections &&
        <Typography className={`status-wrapper ${statusMsgClassname}`}>
          <Typography component='span'>Employee {selectedRegId} has been made </Typography>
          available
          <Typography component='span'> for the NIGHT Dispatch Shift on {employeeData?.empInfo?.shiftDate}.</Typography>
        </Typography>}
      {isNightDispatch && employeeData && !employeeData?.empInfo?.doaSelections && !!employeeData.empInfo.dependentShift?.doaSelections &&
        <Typography className={`status-wrapper ${statusMsgClassname}`}>
          <Typography component='span'>Employee {selectedRegId} has been made </Typography>
          available
          <Typography component='span'> for the GRAVEYARD Dispatch Shift on {employeeData?.empInfo?.dependentShift?.shiftDate}.</Typography>
        </Typography>}
    </>}
  </Box>
)